module.exports = __webpack_public_path__ + "static/media/industries-fertilizer-s.e076444f.jpg";